var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompany4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9783 3.11148L19.2957 6.18212L21.9919 4.62978L13.9783 0L0.592773 7.73445L3.27532 9.28679L13.9783 3.11148Z",
    fill: "#64748B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6766 6.18212L13.9804 12.3574L8.66299 9.28679L5.97363 10.8391L13.9804 15.4621L27.3727 7.73446L24.6766 6.18212Z",
    fill: "#64748B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.746 16.5719L0.0566406 15.0196V24.2655L13.4421 32V28.8953L2.746 22.7132V16.5719Z",
    fill: "#64748B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0566406 11.9148L10.7528 18.0901V24.2314L13.4421 25.7905V16.5378L0.0566406 8.81012V11.9148Z",
    fill: "#64748B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5322 15.0195V11.9149L14.5186 16.5378V31.9999L17.2079 30.4476V18.0902L22.5322 15.0195Z",
    fill: "#64748B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2139 10.3625V22.7131L19.8965 25.7905V28.8952L27.9101 24.2654V8.81012L25.2139 10.3625Z",
    fill: "#64748B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany4);
export default __webpack_public_path__ + "static/media/company4.c0d1ebd45b3c1b1e1301bd4e9cc01a1e.svg";
export { ForwardRef as ReactComponent };